import React from 'react';
import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Radio,
  RadioGroup,
  Stack,
  Text,
} from '@chakra-ui/react';
import { Property, SystemTranslationKeys } from '@common/entities';

import { useSystemTranslation } from 'hooks';

interface Props {
  isOpen: boolean;
  onBack: () => void;
  onNext: () => void;
  properties: Property[];
  setSelectedPropertyId: (id: string) => void;
}
export function TargetApplicationPropertyModal(props: Props) {
  const { tSystem } = useSystemTranslation();
  const { onNext, onBack, isOpen, properties, setSelectedPropertyId } = props;
  const [propertySelected, setPropertySelected] = React.useState(false);
  properties.sort((a, b) => a.propertyName.localeCompare(b.propertyName));

  const handleClose = (action: string) => {
    if (action === 'Next') {
      onNext();
    } else {
      onBack();
    }
  };

  return (
    <Modal
      size="xs"
      isCentered
      isOpen={isOpen}
      closeOnEsc={false}
      onClose={() => {}}
      closeOnOverlayClick={false}
    >
      <ModalOverlay bg="black.200" backdropFilter="blur(12px) hue-rotate(0deg)" />
      <ModalContent bg="white.base" border="1px" borderColor="gray.light" borderRadius={8}>
        <ModalBody px={6} py={8}>
          <Text fontSize="md" fontWeight="bold" textAlign="center">
            {tSystem(SystemTranslationKeys.common.propertySelectionPrompt)}
          </Text>
          <br />
          <Text textAlign="center" wordBreak="break-word">
            <RadioGroup>
              <Stack direction="column">
                {properties.map((prop: Property) => (
                  <Radio
                    key={`target-properties-${prop.propertyId}`}
                    value={prop.propertyId.toString()}
                    onChange={(e) => {
                      setSelectedPropertyId(e.target.value);
                      setPropertySelected(true);
                    }}
                  >
                    {prop.propertyName}
                  </Radio>
                ))}
              </Stack>
            </RadioGroup>
          </Text>
        </ModalBody>
        <ModalFooter borderBottomRightRadius={8} borderBottomLeftRadius={8} bg="silver.essence">
          <Flex justifyContent="center" width="100%">
            <Button size="sm" onClick={() => handleClose('Back')} mr={4}>
              {tSystem(SystemTranslationKeys.nav.back)}
            </Button>
            <Button
              size="sm"
              onClick={() => handleClose('Next')}
              mr={4}
              isDisabled={!propertySelected}
            >
              {tSystem(SystemTranslationKeys.nav.next)}
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
